type ReturnPromiseFn = () => Promise<any>;
type NpAsyncTask = ReturnPromiseFn | Promise<any>;

export class NpTaskAll {

    private _tasks: NpAsyncTask[] = [];

    add(task: NpAsyncTask) {
        this._tasks.push(task);
    }

    run() {
        let taskRun$: Promise<any>;
        if (!this._tasks || this._tasks.length > 0) {
            taskRun$ = Promise.all(
                // this._tasks.map(t => (typeof t === 'function') ? t() : t));
                this._tasks.map(task => {
                    if (typeof task === 'function') {
                        return task();
                    } else if (task instanceof Promise) {
                        return task;
                    } else {
                        throw new Error("Invalid task type. Task must be a function or a Promise.");
                    }
                }));
        } else {
            taskRun$ = Promise.resolve();
        }
        return taskRun$;
    }

}